import React, { FC, useState } from 'react'
import TabTile from '../../../../components/TabTile'
import TextForm from '../../../../components/TextForm'
import { Highlighted } from 'tabs/data/components/Highlighted'
import { DataRule } from '../../rules.types'

type RuleTileProps = {
  search: string
  index: number
  rule: DataRule
}

export const RuleTile: FC<RuleTileProps> = ({ index, rule, search }) => {
  const [expandedRule, setExpandedRule] = useState('')

  const handleChangeExpandedRule = (tableId: string) => {
    const nextValue = expandedRule !== tableId ? tableId : ''
    setExpandedRule(nextValue)
  }

  const handleRuleChange = async (t, textTitle) => {
    alert('Development in progress')
  }

  const isRuleHidden = (...params) => {
    return search && !params.some(i => (i || '').toString().toLowerCase().includes(search.toLowerCase()))
  }

  if (isRuleHidden(rule.metrics)) return null

  return (
    <TabTile
      tab={{
        name: <Highlighted text={rule.metrics} highlight={search} />,
        icon: `${index + 1}`,
        description: rule.rule,
      }}
      expanded={rule.id === expandedRule}
      onChange={() => handleChangeExpandedRule(rule.id)}>
      <TextForm
        isFromEdit
        updatedAt={new Date().getTime()}
        submitButtonLabel="Save changes"
        inputDescription="Rule information"
        inputText={rule.metrics}
        textAreaContent={rule.rule}
        onClick={handleRuleChange}
      />
    </TabTile>
  )
}
